import { useThemeClass } from "@/Hooks/useThemeClass";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import clsx from 'clsx';
import { faqData, FAQCategory, FAQItem } from "../faqData";

function Faq() {
  const themClass = useThemeClass()
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);
  const typeRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const [activeType, setActiveType] = useState("");

  const setRef = (type: string, el: HTMLDivElement | null) => {
    if (el && !typeRefs.current[type]) {
      typeRefs.current[type] = el;
    }
  };

  const toggleFAQ = (id: number) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  const scrollRef = useRef<HTMLDivElement | null>(null);

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 200, behavior: "smooth" });
  };

  return (
    <div className="px-4 pb-4">
      <div className="mb-6 sticky top-[57px] z-10 bg-white overflow-x-auto w-full no-scrollbar">
        <div className="relative flex items-center">
          <button
            onClick={scrollLeft}
            className="absolute left-0 z-20 bg-white p-1 shadow-md rounded-full"
          >
            <ChevronLeft size={20} />
          </button>
          <div ref={scrollRef} className="overflow-x-auto no-scrollbar w-full mx-2">
            <div className="grid grid-cols-9 gap-1 w-max text-center px-2 border-b border-gray-400">
              {faqData.map((el: FAQCategory) => (
                <div
                  key={el.type}
                  onClick={() => {
                    const elRef = typeRefs.current[el.type];
                    setActiveType(el.type);
                    if (elRef) {
                      elRef.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }}
                  className={`px-4 py-4 whitespace-nowrap transition-all w-full ${
                    activeType === el.type
                      ? "border-b border-[#46B6D0] pb-5 font-bold text-[#46B6D0]"
                      : "bg-white text-gray-800"
                  }`}
                >
                  {el.type}
                </div>
              ))}
            </div>
          </div>
          <button
            onClick={scrollRight}
            className="absolute right-0 z-20 bg-white p-1 shadow-md rounded-full"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      {faqData.map((el: FAQCategory, index: number) => {
        return (
          <div
            key={index}
            ref={(node) => setRef(el.type, node)}
            id={el.type}
            className="scroll-mt-20"
          >
            <div className="flex flex-col gap-2 border-b border-black pb-3 mt-3">
              <div className="flex justify-between items-center gap-2">
                <h1 className="font-bold text-xl ">{el.type}</h1>
                <Link
                  to="http://pf.kakao.com/_VGfsn"
                  className={el.type !== "신청" ? "hidden" : ""}
                >
                  <button className={clsx(themClass.bg('text'), `text-center text-white py-2 rounded-full w-[20vw] text-sm`)}>
                    1:1 문의
                  </button>
                </Link>
              </div>
            </div>

            {el.data.map((faq: FAQItem) => (
              <div key={faq.id} className="border-b border-gray-300 ">
                <div
                  className={`flex justify-between p-2 py-5 ${
                    openFAQ === faq.id
                      ? clsx(themClass.bg('background'), 'font-bold border-b border-gray-300')
                      : ""
                  }`}
                  onClick={() => toggleFAQ(faq.id)}
                >
                  <p>{faq.question}</p>
                  <svg
                    className={`w-6 h-6 text-gray-800 transition-transform duration-600 ${
                      openFAQ === faq.id ? "rotate-180" : "rotate-0"
                    }`}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                      d="m19 9-7 7-7-7"
                    />
                  </svg>
                </div>

                {openFAQ === faq.id && (
                  <div className={clsx(themClass.bg('background'), `p-2 py-5 text-sm text-gray-500 whitespace-pre-line`)}>
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}

export default Faq;